import { AxiosRequestConfig } from 'axios'

const addRating = (id: string, data: number): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: `/events/rating`,
    data: {
      id,
      rating: data
    }
  }
}

export default addRating
